// extracted by mini-css-extract-plugin
export default {"error":"P_clfgLoP13CdwKckKiA","title":"gMwdD0tmwdknQpAtzbJv","detail":"FN4noSZx4q1aa6iZELZC"};